// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2848":"css/app.6818","5603":"css/admin-app.6818"}[chunkId] + ".css";
};